"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionFactory = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var divider_1 = require("../../components/deprecated/divider");
var DropdownOption_st_css_1 = require("./DropdownOption.st.css");
var uniqueId = require('lodash/uniqueId');
var compact = require('lodash/compact');
var createOption = function (option) {
    if (option === void 0) { option = null; }
    return (tslib_1.__assign({ id: option && (option.id || option.id === 0) ? option.id : uniqueId('Option'), isDisabled: false, isSelectable: true, value: null, render: function (val) { return val; } }, option));
};
var escapeRegExp = function (s) { return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); };
var highlightRegExt = function (s) {
    return new RegExp("(" + s.replace(/ /g, '|') + ")", 'gi');
};
var isEven = function (i) { return i % 2 === 0; };
var isOdd = function (i) { return i % 2 === 1; };
var highlightMatches = function (option, searchTerm) {
    var regExp = highlightRegExt(escapeRegExp(searchTerm.trim()));
    var stringArray = option.value.split(regExp);
    var f = stringArray[0] === '' ? isEven : isOdd;
    var parts = compact(stringArray).map(function (part, i) {
        return f(i) ? (React.createElement("mark", { className: DropdownOption_st_css_1.classes.highlight, key: i }, part)) : (React.createElement("span", { className: DropdownOption_st_css_1.classes.nonHighlight, key: i }, part));
    });
    return createOption({
        id: option.id,
        isDisabled: option.isDisabled,
        isSelectable: option.isSelectable,
        value: option.value,
        render: function () { return option.render(parts); },
    });
};
exports.OptionFactory = {
    create: createOption,
    createDivider: function (_a) {
        var _b = _a === void 0 ? {} : _a, className = _b.className, value = _b.value;
        return createOption({
            id: uniqueId('Divider'),
            isDisabled: false,
            isSelectable: false,
            render: value
                ? function () { return React.createElement(divider_1.Divider, { className: className }, value); }
                : function () { return React.createElement(divider_1.Divider, { className: className }); },
        });
    },
    createHighlighted: function (option, highlightValue) {
        return option.value && highlightValue
            ? highlightMatches(option, highlightValue)
            : option;
    },
};
//# sourceMappingURL=OptionFactory.js.map